import { formatColumnLabel } from "../Accounts/assetUtils.js";
import { formatSimTimestamp } from "../../api/endpoints/sims.js";

export const SIM_FORM_EMPTY = {
  iccid: "",
  msisdn: "",
  carrier: "",
  simTypeId: "",
  status: "active",
  values: {},
};

export const SIM_STATUSES = ["active", "suspended", "inactive"];

export function simToForm(sim) {
  if (!sim) return { ...SIM_FORM_EMPTY, values: {} };
  return {
    iccid: sim.iccid ?? "",
    msisdn: sim.msisdn ?? "",
    carrier: sim.carrier ?? "",
    simTypeId: sim.simTypeId ?? "",
    status: SIM_STATUSES.includes(sim.status) ? sim.status : "active",
    values: { ...(sim.values ?? {}) },
  };
}

export function simFormToPayload(form, simType) {
  return {
    iccid: form.iccid.trim(),
    msisdn: form.msisdn.trim(),
    carrier: form.carrier.trim(),
    simTypeId: form.simTypeId.trim(),
    simType: simType?.name ?? "",
    status: form.status,
    values: form.values ?? {},
  };
}

export function validateSimStep(form, step, simType, isEdit) {
  const errors = {};
  if (step === 1) {
    if (!isEdit && !form.iccid?.trim()) errors.iccid = "ICCID is required";
    if (!form.msisdn?.trim()) errors.msisdn = "MSISDN is required";
    if (!form.carrier?.trim()) errors.carrier = "Carrier is required";
    if (!form.simTypeId?.trim()) errors.simTypeId = "SIM type is required";
    if (!SIM_STATUSES.includes(form.status)) errors.status = "Select a status";
    return errors;
  }

  const columns = simType?.columns ?? [];
  const valueErrors = {};
  columns.forEach((col) => {
    const raw = form.values?.[col.key];
    if (!String(raw ?? "").trim()) {
      valueErrors[col.key] = `${formatColumnLabel(col.key)} is required`;
      return;
    }
    if (col.type === "int" && !/^-?\d+$/.test(String(raw).trim())) {
      valueErrors[col.key] = "Enter a whole number";
    }
  });
  if (Object.keys(valueErrors).length) errors.values = valueErrors;
  return errors;
}

export function buildSimListSubtitle(sim, simType) {
  const parts = [sim.carrier, simType?.name ?? sim.simType].filter(Boolean);
  if (parts.length) return parts.join(" · ");
  return sim.msisdn ?? "SIM";
}

export function buildSimDetailFields(sim, simType) {
  if (!sim) return [];
  const fields = [
    { label: "ICCID", value: sim.iccid, icon: "sim" },
    { label: "MSISDN", value: sim.msisdn, icon: "device" },
    { label: "Carrier", value: sim.carrier, icon: "building" },
    { label: "SIM type", value: simType?.name ?? sim.simType ?? "—", icon: "layers" },
    { label: "Status", value: sim.status, icon: "model" },
  ];
  (simType?.columns ?? []).forEach((col) => {
    fields.push({
      label: formatColumnLabel(col.key),
      value: sim.values?.[col.key] ?? "—",
      icon: col.type === "int" ? "grid" : col.type === "file" ? "layers" : "model",
    });
  });
  fields.push(
    { label: "Created at", value: formatSimTimestamp(sim.createdAt), icon: "device", wide: true },
    { label: "Updated at", value: formatSimTimestamp(sim.updatedAt), icon: "device", wide: true },
  );
  return fields;
}

export function buildSimDetailRows(fields) {
  const gridFields = fields.filter((f) => !f.wide);
  const wideFields = fields.filter((f) => f.wide);
  const rows = [];
  for (let i = 0; i < gridFields.length; i += 2) {
    rows.push(gridFields.slice(i, i + 2));
  }
  wideFields.forEach((field) => rows.push([field]));
  return rows;
}

export function simSearchHaystack(sim) {
  return [sim.iccid, sim.msisdn, sim.carrier, sim.simType, sim.status, Object.values(sim.values ?? {}).join(" ")]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}
